
import React from 'react';

export const DashboardIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    dashboard
  </span>
);